import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import CrossIconRed from "../../../../assets/svg/icons/common/CrossIconRed";
import CheckMarkGreen from "../../../../assets/svg/icons/common/CheckMarkGreen";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";
import { isDisputeRecoveryVisible } from "../../../../utils/is-dispute-recovery-visible";
import { getMultiLocationItems } from "../../../../../components/helper/helper";

function BusinessProfile({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);

  const disputeRecoveryVisible = isDisputeRecoveryVisible(appData?.organization_id);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const renderYesNo = (value) => {
    if (value !== "" && value !== undefined && value !== null) {
      return value === "yes" ? (
        <>
          <CheckMarkGreen /> Yes
        </>
      ) : (
        <>
          <CrossIconRed /> No
        </>
      );
    } else {
      return "-";
    }
  };

  const normalizeToArray = (value) => {
    if (!value) return []; // handles null, undefined, empty

    if (Array.isArray(value)) {
      return value.map((v) => ucfirst(v)); // ensure ucfirst here
    }

    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map((v) => ucfirst(v));
      }
    } catch (e) {
      // not JSON
    }

    return [ucfirst(value)];
  };

  const ucfirst = (str) => {
    str = String(str);
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const formatAdvertiseDesc = (value) => {
    if (!value) return "-";
    
    try {
      if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
        const parsedValue = JSON.parse(value);
        if (Array.isArray(parsedValue)) {
          return parsedValue.map(item => {
            const cleanItem = item.replace(/['"]/g, '');
            return cleanItem.charAt(0).toUpperCase() + cleanItem.slice(1);
          }).join(", ");
        }
      }
      
      if (Array.isArray(value)) {
        return value.map(item => {
          const cleanItem = typeof item === 'string' ? item.replace(/['"]/g, '') : item;
          return cleanItem.charAt(0).toUpperCase() + cleanItem.slice(1);
        }).join(", ");
      }
      
      return value;
    } catch (e) {
      return value;
    }
  };

  const renderSection = (title, items) => {
    return (
      <div className={styles.info_section}>
        {title && (
          <>
            <div className={styles.section_title}>
              <h5>{title}</h5>
            </div>
            <div className={styles.desktop_heading}>
              <HeadingWithLine text={title} />
            </div>
          </>
        )}
        <div className={styles.info_grid}>
          {items.map((item, index) => (
            <div key={index} className={styles.info_item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          ))}
        </div>
        <ul className={styles.desktop_list}>
          {items.map((item, index) => (
            <li key={index}>
              <div>
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const profile = appData?.powerappbusinessprofile;

  const businessProfileItems = [
    { label: "Products and services description", value: profile?.product_service_sold || "-" },
    { label: "Products and/or services are advertised", value: formatAdvertiseDesc(profile?.prod_advertise_desc) },
    { label: "3rd party application involved with payment process", value: (
      <>
        {renderYesNo(profile?.thirdparty_delivered_radio)}
        {appData?.creditcardprocess?.third_party_identity ? ` ( ${appData?.creditcardprocess?.third_party_identity} )` : ""}
      </>
    ) },
    { label: "Business PCI compliant", value: renderYesNo(appData?.creditcardprocess?.pci_complaint) },
    { label: "Business or any associated owner ever been terminated as a VISA/MasterCard/Discover/AMEX merchant?", value: renderYesNo(appData?.creditcardprocess?.terminated_as_vmdax) },
    { label: "Business had any ongoing or prior data compromise investigations", value: renderYesNo(appData?.creditcardprocess?.prior_data_compromise_invetigation) },
    { label: "Business was previously identified with Visa Risk Programs", value: (
      <>
        {renderYesNo(appData?.creditcardprocess?.identified_visa_risk_program)}
        {profile?.thirdparty_sales_per_desc ? ` ( ${profile?.thirdparty_sales_per_desc} )` : ""}
      </>
    ) },
    { label: "Multiple locations", value: renderYesNo(profile?.is_multiple_locations) },
    ...getMultiLocationItems(profile),
    ...(disputeRecoveryVisible
      ? [{
          label: "Dispute Recovery Program",
          value: appData?.dispute_recovery_program !== false
            ? (<><CheckMarkGreen /> Opted In</>)
            : (<><CrossIconRed /> Opted Out</>),
        }]
      : []),
  ];

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.business_profile} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={isMobile ? styles.business_info_header : styles.head} onClick={toggleExpanded}>
        {isMobile ? (
          <>
            <CaretRight24 className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`} />
            <h4>Business Profile</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Business Profile</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && renderSection(null, businessProfileItems)}
      </div>
    </div>
  );
}

export default BusinessProfile;
